










































import ActionButton from '@/components/ActionButton.vue'
import { TableHeader, Params } from '@/utils/interfaces'
import { Transaction } from '@/utils/interfaces/topup.interface'
import TransactionsDetailsButton from '@/components/Agency/Transactions/TransactionsDetailsButton.vue'
import { formatDate } from '@/utils/functions'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { getWholesalerTransactions } from '@/api/Remittances/remittances.api'
import BillTransactionsFilter from '@/components/Agency/Transactions/BillTransactionsFilter.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<Transaction>().extend({
  components: {
    appActionButton: ActionButton,
    TransactionsDetailsButton,
    appBillTransactionsFilter: BillTransactionsFilter,
    FlatCard,
    FlatTable,
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t('created_by'),
          value: 'created_by',
        },
        {
          text: this.$t('user.user'),
          value: 'with_user_name',
        },
        {
          text: this.$t('date'),
          value: 'created_at',
        },
        {
          text: this.$t('amount'),
          value: 'amount',
        },
        {
          text: this.$t('details'),
          value: 'details',
        },
      ] as TableHeader[],
      getter: (params?: Params) => {
        if (
          this.$store.getters.profile.role === 'ADMIN' &&
          !this.$store.getters.is_superuser
        ) {
          return getWholesalerTransactions({ ...params, from_agency: true })
        } else return getWholesalerTransactions(params)
      },
      detailsItem: null as null | Transaction,
      detailsDialog: false,
    }
  },
  methods: {
    onDetails(item: Transaction) {
      this.detailsItem = item
      this.detailsDialog = true
    },
    formatDate(date: string) {
      return formatDate(date)
    },
  },
})
